import React, { ReactElement, useEffect, useMemo } from 'react';
import { Product } from '../../Models/Product';
import './ReaderEndCard.scss';
import { useHistory } from 'react-router-dom';
import Logo from '../Assets/icons/haeder-white.png';
import ProductPoster from '../KodanshaUIKit/ProductPoster/ProductPoster';
import KodanshaSubmit from '../KodanshaUIKit/KodanshaSubmit/KodanshaSubmit';
import KodanshaUnderlinedText from '../KodanshaUIKit/KodanshaUnderlinedText/KodanshaUnderlinedText';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { CheckoutOverlayVisible, LoginOverlayVisible } from '../../store/OverlayStore';
import { ReactComponent as SvgArrow } from '../Assets/icons/ARROW-SHARP.svg';
import {
    convertDate,
    isTheChapterInCart,
    isTheChapterPurchased,
    isTheVolumeInCart,
    isTheVolumePurchased,
} from '../../utils/utils';
import { FetchMyBooksAtom } from '../../store/MyBooksStore';
import { Cart } from '../../Models/Cart';
import { AddToCartAction, CartAtom, DeductFromCartAction } from '../../store/CartStore';
import dayjs from 'dayjs';
import { LoginAtom, LoginStatus, LoginStatusAtom } from '../../store/AccountStore';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import { ReaderIsFullScreen } from '../../store/ReaderStore';
import Dinero from 'dinero.js';
import { Variant } from '../../Models/Product/Variant';

export const ReaderEndCardWrapper = (props): ReactElement => {
    return <div className={'ReaderEndCard'}>
        <img src={Logo} className={'ReaderEndCard-logo'} />
        {props.children}
    </div>;
};

export const ReaderEndCardModal = (props): ReactElement => {
    const history = useHistory();
    return <div className={'next-is-owned-modal'}>
        <span className='next-is-owned-modal-title'>
            {props.title}
        </span>
        <div className='next-is-owned-modal-divider' />
        {props.children}
        <div className='next-is-owned-modal-divider-2' />

        <span className='next-is-owned-modal-end-wrapper'>
            {props.end && props.end()}
            <div className={'end-button'} onClick={() => props.onBackCallback()}>
            <KodanshaUnderlinedText text={'Back'} />
            </div>
            <div className={'horizontal-separator'}></div>
            <div className={'end-button'} onClick={() => props.onCloseCallback()}>
                <KodanshaUnderlinedText text={'Close Reader'} />
            </div>
        </span>

    </div>;
};

export const ReaderStartCardModal = (props): ReactElement => {

    const history = useHistory();
    return <div className={'next-is-owned-modal'}>
        <span className='next-is-owned-modal-title'>
            {props.title}
        </span>
        <div className='next-is-owned-modal-divider' />
        {props.children}


        {props.end && (<div className={'next-is-owned-modal-end-container'}>{props.end()}</div>)}
        <div className='next-is-owned-modal-divider-2' />

        <span className='next-is-owned-modal-end-wrapper'>
            <div className={'end-button'} onClick={() => history.goBack()}>
            <KodanshaUnderlinedText text={'Back'} />
            </div>
            <div className={'horizontal-separator'}></div>
            <div className={'end-button'} onClick={() => props.onCloseCallback()}>
                <KodanshaUnderlinedText text={'Close Reader'} />
            </div>
        </span>

    </div>;
};

export const ProductInMiddle = (props) => {
    const [myBooks, fetchBooks] = useAtom(FetchMyBooksAtom);
    const nextProductOwned = myBooks.find(x => x.id == props.nextProduct.id);

    return <div className='next-is-owned-modal-middle-wrapper-product-wrapper'>
        <div className='product-wrapper-with-sale'>

            {props.nextProduct.variants && props.nextProduct.variants[0]?.isOnSale &&
                <span className='is-on-sale-tag-reader'>
                 ON SALE
             </span>}

            <ProductPoster src={props.nextProduct.thumbnails[0].url}
                           alt={'Cover of ' + props.nextProduct.name} />
        </div>
        <div className='next-is-owned-modal-middle-wrapper-product-info-wrapper'>
                                <span className='product-info-name'>
                                    {props.nextProduct.name}
                                </span>
            <span className='product-info-date'>
                                    {convertDate(props.nextProduct.publishDate)}
                                </span>
            <span className='product-info-pages'>
                                    {props.nextProduct.readable.pageCount} pages
                                </span>

            <div className='product-info-price-wrapper'>

                {Variant.IsPurchaseable(props.nextProduct.variants[0] as Variant) && (
                    <>
                        {props.nextProduct.variants[0] != null && props.nextProduct.variants[0]?.isOnSale &&
                            <span
                                className={`product-info-price product-info-price-with-discount`}>
                                   {nextProductOwned ? 'In Library' : '$' + props.nextProduct.variants[0].fullPrice.toFixed(2)}
                                </span>
                        }

                        {props.nextProduct.variants[0] != null && !props.nextProduct.variants[0]?.isOnSale &&
                            <span
                                className={`product-info-price`}>
                                   {nextProductOwned ? 'In Library' : (props.nextProduct.variants[0].price as Dinero.Dinero).toFormat()}
                                </span>
                        }

                        {props.nextProduct.variants[0] != null && props.nextProduct.variants[0]?.isOnSale &&
                            <span className='product-info-price-discount'>
                                   {nextProductOwned ? 'In Library' : (props.nextProduct.variants[0].price as Dinero.Dinero).toFormat()}
                                </span>}
                    </>
                )}
            </div>
        </div>
    </div>;

};

interface ReaderEndCardProps {
    currentProduct: Product;
    nextProduct?: Product;
    onReturnToChapterClicked?: (...args) => any;
    isOwnedByUser: boolean;
    onCloseReader: () => void;
    onGoBack: () => void;
}

export function ReaderEndCard(props: ReaderEndCardProps): ReactElement {
    const history = useHistory<{ returnPath: string }>();
    const SetLoginOverlay = useSetAtom(LoginOverlayVisible);
    const [myBooks, fetchBooks] = useAtom(FetchMyBooksAtom);
    const cart = useAtomValue<Cart | false>(CartAtom);
    const removeFromCart = useSetAtom(DeductFromCartAction);
    const setCheckoutOverlay = useSetAtom(CheckoutOverlayVisible);
    const loginStatus = useAtomValue(LoginAtom);
    const [, addToCart] = useAtom(AddToCartAction);
    const [isLoggedIn] = useAtom(LoginStatusAtom);
    const setIsFullScreenEnabled = useSetAtom(ReaderIsFullScreen);

    function closeReader() {
        props.onCloseReader();
    }

    function goBack() {
        props.onGoBack();
    }

    useEffect(() => {
        fetchBooks();
    }, []);

    const nextProductPriceType = useMemo(() => {
        if (!props.nextProduct) {
            return false;
        }
        return props.nextProduct.variants[0]?.priceType;
    }, [props.nextProduct]);

    const isNextProductOwned = useMemo(() => {
        if (!props.nextProduct) {
            return false;
        }
        return (props.nextProduct as Product).subCategory === 'Volume' ? isTheVolumePurchased(myBooks, props.nextProduct.id) : isTheChapterPurchased(myBooks, props.nextProduct, props.nextProduct.volumeNumber);
    }, [props.nextProduct, myBooks]);

    const isItemInTheCart = useMemo(() => {
        if (!props.nextProduct) {
            return false;
        }
        return isTheVolumeInCart(cart, props.nextProduct) || isTheChapterInCart(cart, props.nextProduct);
    }, [cart, props.nextProduct]);

    if (!props.currentProduct) {
        return null;
    }

    const onCartRemoveClicked = async () => {
        await removeFromCart({ productId: props.nextProduct.id, variantId: props.nextProduct.variants[0]?.id });
    };

    const onCartAddClicked = async (_loginStatus: LoginStatus) => {
        const priceType = nextProductPriceType;
        const hasBook = isNextProductOwned;

        if (priceType === 'Free') {
            // TODO: THIS IS A HOTFIX. We need to enforce a refresh so that the reader state resets properly
            //history.push('/reader/' + props.nextProduct.id);
            window.location.href = '/reader/' + props.nextProduct.id;
            return;
        }

        if (priceType === 'FreeForRegistered' && _loginStatus === 'LoggedIn') {
            // TODO: THIS IS A HOTFIX. We need to enforce a refresh so that the reader state resets properly
            window.location.href = '/reader/' + props.nextProduct.id;
            //history.push('/reader/' + props.nextProduct.id);
            return;
        }

        if (priceType === 'FreeForRegistered' && _loginStatus !== 'LoggedIn') {
            SetLoginOverlay(true);
            return;
        }

        if (hasBook) {
            // TODO: THIS IS A HOTFIX. We need to enforce a refresh so that the reader state resets properly
            //history.push('/reader/' + props.nextProduct.id);
            window.location.href = '/reader/' + props.nextProduct.id;
            return;
        }

        if (props.nextProduct.publishDate.isAfter(dayjs())) {
            return;
        }

        await addToCart({ productId: props.nextProduct.id, variantId: props.nextProduct.variants[0]?.id });
        // setIsActive(true);
    };

    // If there is a next product in this series
    if (props.nextProduct) {
        if (isNextProductOwned) {
            console.debug('[KodanshaEndCard]Next product in series is available, and user owns the next product in the series.');
            // Lars said no need to block the user on this case, so this condition will removed. (For Krister)
            return (

                <ReaderEndCardWrapper>
                    <ReaderEndCardModal title={'You\'ve purchased this product'} onCloseCallback={closeReader}
                                        onBackCallback={goBack}>
                        <div className='next-is-owned-modal-middle-wrapper'>
                            {/*<span className='next-is-owned-modal-text'>*/}
                            {/*    Read For Free*/}
                            {/*</span>*/}

                            <ProductInMiddle nextProduct={props.nextProduct} />

                            <KodanshaSubmit onSubmitClicked={() => onCartAddClicked(loginStatus)}
                                            text={'Read'}
                                            styles={'submit-button'} />

                        </div>
                    </ReaderEndCardModal>
                </ReaderEndCardWrapper>

            );
        }

        // TODO: Implement Read for free logic
        if (nextProductPriceType === 'Free') {
            // Lars said no need to block the user on this case, so this condition will removed. (For Krister)
            console.debug('Next Product is completely free to read.');
            return (<ReaderEndCardWrapper>
                <ReaderEndCardModal title={'Read For Free'} onCloseCallback={closeReader} onBackCallback={goBack}>
                    <div className='next-is-owned-modal-middle-wrapper'>
                        {/*<span className='next-is-owned-modal-text'>*/}
                        {/*    Read For Free*/}
                        {/*</span>*/}

                        <ProductInMiddle nextProduct={props.nextProduct} />

                        <KodanshaSubmit onSubmitClicked={() => onCartAddClicked(loginStatus)}
                                        text={'Read for free'}
                                        styles={'submit-button'} />

                    </div>
                </ReaderEndCardModal>
            </ReaderEndCardWrapper>);
        }

        // TODO: Implement Read-for free when logged in state
        if (nextProductPriceType === 'FreeForRegistered') {
            console.debug('Next Product is free to read but it requires the user to log in.');
            return (
                <ReaderEndCardWrapper>
                    <ReaderEndCardModal title={'Login to read for free'} onCloseCallback={closeReader}
                                        onBackCallback={goBack}>
                        <div className='next-is-owned-modal-middle-wrapper'>
                      <span className='next-is-owned-modal-text'>
                          Create an account or log in to an existing one to read this content for free!
                      </span>

                            <ProductInMiddle nextProduct={props.nextProduct} />


                            {loginStatus == 'LoggedIn' && (
                                <KodanshaSubmit onSubmitClicked={
                                    () => onCartAddClicked(loginStatus)}
                                                text={'Read for free'}
                                                styles={'submit-button'} />
                            )}
                            {loginStatus != 'LoggedIn' && (
                                <KodanshaSubmit onSubmitClicked={() => {
                                    setIsFullScreenEnabled(false);
                                    SetLoginOverlay(true);
                                }
                                }
                                                text={'log in or sign up'}
                                                styles={'submit-button'} />
                            )}

                        </div>
                    </ReaderEndCardModal>
                </ReaderEndCardWrapper>
            );
        }


        console.debug('[KodanshaEndCard]Next product in series is available, but user does not own the next product in series.');
        return (<ReaderEndCardWrapper>
            <ReaderEndCardModal title={'Purchase Volume'} end={() => {
                return loginStatus !== 'LoggedIn' ? <div className='already-own-product-wrapper'>
                    <div className='already-own-product-text'>
                        Already own this product?
                    </div>

                    <KodanshaUnderlinedText text={'Log In'} onClick={() => SetLoginOverlay(true)} />
                </div> : null;
            }} onCloseCallback={closeReader} onBackCallback={goBack}>
                <div className='next-is-owned-modal-middle-wrapper'>
                      <span className='next-is-owned-modal-text'>
                          You need to purchase this product to access it.
                      </span>

                    <ProductInMiddle nextProduct={props.nextProduct} />

                    {isItemInTheCart ?
                        <div className='remove-from-cart-wrapper'>
                            <div className='remove-from-cart-inner-wrapper'>
                                <span className='product-added-text'>Product added to cart</span>
                                <span onClick={onCartRemoveClicked} className='product-remove-text'>Remove</span>
                            </div>

                            <div className='remove-from-cart-inner-wrapper'>
                                <div onClick={() => {
                                    history.push('/');
                                    if (isLoggedIn === 'LoggedIn') {
                                        setCheckoutOverlay(true);
                                    } else {
                                        SetLoginOverlay(true);
                                    }
                                }} className='checkout-button-wrapper'>
                                <span className='checkout-button-text'>
                                    Checkout
                                </span>
                                    <SvgArrow fill={'white'} className={'checkout-button-icon'} />
                                </div>
                            </div>
                        </div>
                        :
                        <KodanshaSubmit text={'Add to cart'} styles={'submit-button'}
                                        onSubmitClicked={() => onCartAddClicked(loginStatus)} />
                    }

                </div>
            </ReaderEndCardModal>
        </ReaderEndCardWrapper>);
        {/*<div className={'cta'}>*/
        }
        {/*    <img src={props.nextProduct.thumbnails[0].url} alt={'Cover of ' + props.nextProduct.name} />*/
        }
        {/*    <div>*/
        }
        {/*        <h3>{props.nextProduct.name}</h3>*/
        }
        {/*        <button onClick={(): void => {*/
        }
        {/*            history.push('/product/' + props.nextProduct.id);*/
        }
        {/*        }*/
        }
        {/*        }>Unlock*/
        }
        {/*        </button>*/
        }
        {/*    </div>*/
        }
        {/*</div>*/
        }

    }

    return (<div className={'ReaderEndCard-catch-up-container'}>
        <img src={Logo} className={'ReaderEndCard-logo'} />
        <div className={'ReaderEndCard-catch-up'}>
            <h3 className={'ReaderEndCard-catch-up-header'}>{'You\'re all caught up!'}</h3>

            <KodanshaArrow text={'Close Reader'}
                           onClick={() => {
                               closeReader();
                           }}
                           styles={'ReaderEndCard-catch-up-button'}
                           invert={true}
                           withArrow={false} />

            {props.currentProduct?.chapterNumber ?
                <KodanshaArrow text={'Return to chapter ' + props.currentProduct?.chapterNumber}
                               styles={'ReaderEndCard-catch-up-button-2'}
                               onClick={props.onReturnToChapterClicked ?
                                   props.onReturnToChapterClicked() : (): void => {
                                       console.log('No Function Declared On Chapter Clicked');
                                   }}
                               invert={true}
                               withArrow={true} /> :
                <KodanshaArrow text={'Return to manga'}
                               onClick={() => history.push('/series/' + props.currentProduct.series.id)}
                               styles={'ReaderEndCard-catch-up-button-2'}
                               invert={true}
                               withArrow={true} />
            }
        </div>
    </div>);
}
